class ScreenShare {
  getVersion() {
    let request = {
      type: 'getVersion'
    }

    return new Promise(function (resolve, reject) {
      window.chrome.runtime.sendMessage(process.env.REACT_APP_CHROME_EXTENSION_ID, request, function (response) {
        switch (response && response.type) {
          case 'success':
            resolve(response);
            break;
          case 'error':
            reject(new Error('Error'));
            break;
          default:
            reject(new Error('Unknown response'));
            break;
        }
      });
    })
  }

  showWindow() {
    let request = {
      type: 'normalWindow'
    }

    return new Promise(function (resolve, reject) {
      window.chrome.runtime.sendMessage(process.env.REACT_APP_CHROME_EXTENSION_ID, request, function (response) {
        switch (response && response.type) {
          case 'success':
            resolve();
            break;

          case 'error':
            reject(new Error('Error'));
            break;

          default:
            reject(new Error('Unknown response'));
            break;
        }
      });
    })
  }

  minimizeWindow() {
    let request = {
      type: 'minimizeWindow'
    }

    return new Promise(function (resolve, reject) {
      window.chrome.runtime.sendMessage(process.env.REACT_APP_CHROME_EXTENSION_ID, request, function (response) {
        switch (response && response.type) {
          case 'success':
            resolve();
            break;

          case 'error':
            reject(new Error('Error'));
            break;

          default:
            reject(new Error('Unknown response'));
            break;
        }
      });
    });
  }

  start() {
    let request = {
      type: 'getUserScreen',
      sources: ['screen', 'window']
    };

    return new Promise(function (resolve, reject) {
      window.chrome.runtime.sendMessage(process.env.REACT_APP_CHROME_EXTENSION_ID, request, function (response) {
        switch (response && response.type) {
          case 'success':
            resolve(response.streamId);
            break;

          case 'error':
            reject(new Error("Error"));
            break;

          default:
            reject(new Error('Unknown response'));
            break;
        }
      });
    }).then(function (streamId) {
      return navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          mandatory: {
            chromeMediaSource: 'desktop',
            chromeMediaSourceId: streamId,
            // You can provide additional constraints. For example,
            // maxWidth: 1920,
            // maxHeight: 1080,
            // maxFrameRate: 10,
            // minAspectRatio: 1.77
          }
        }
      });
    });
  }
}

export default ScreenShare;